const tag = Symbol('resolved');

export interface Resolved<T> {
  tag: symbol;
  value: T;
}

export function isResolved<T = unknown>(value: unknown): value is Resolved<T> {
  return typeof value === 'object'
    && !!value
    && 'tag' in value
    && value.tag === tag;
}

export function withResolved<T>(value: T): Resolved<T> {
  return { tag, value };
}